import { Deserializable } from '../../protocols/deserializable';

export class MfaType implements Deserializable {
  public id!: MfaTypeIdEnum;
  public name!: string;

  public onDeserialize() {}
}

export enum MfaTypeIdEnum {
  TextMessage = 1,
  App = 2,
  None = 3
}
